import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaRobot } from "react-icons/fa";
import '../App.css';

export default function SmartChatBot() {
  const faq = {
    projects: "My projects include web development, mobile apps, and cloud-based solutions. For more info, visit the 'Projects' section on my site.",
    technologies: "I have experience with JavaScript, React, Node.js, HTML, CSS, SQL/MySQL, PostgreSQL, Python, and libraries like Pandas, NumPy, Matplotlib, Seaborn, Scikit-Learn, TensorFlow, Keras, and NLTK. I've built Machine Learning and Deep Learning models using classification, regression, clustering, and neural networks. I've also worked with NLP and tools like Power BI, Tableau, Google Data Studio, and KPI tracking systems.",
    contact: "You can reach me through the contact page on my website or by email at onkar@hotmail.com",
    experience: "I have experience with JavaScript, React, Node.js, HTML, CSS, SQL/MySQL, PostgreSQL, Python, and libraries like Pandas, NumPy, Matplotlib, Seaborn, Scikit-Learn, TensorFlow, Keras, and NLTK. I've built Machine Learning and Deep Learning models using classification, regression, clustering, and neural networks. I've also worked with NLP and tools like Power BI, Tableau, Google Data Studio, and KPI tracking systems.",
    passion: "I'm passionate about creating solutions that solve real-world problems and enhance user experience.",
    teamwork: "Yes, I’ve worked in multidisciplinary teams on agile development projects.",
    education: "I'm a Data Analyst and Data Scientist. I'm currently finishing my studies in Data Engineering and ML Engineering. Since my studies are online, I'm fully available for work.",
    examples: "Yes! You can find examples of my work in the 'Projects' section on my website.",
    availability: "I'm fully available. For more details, feel free to contact me. Thank you!",
    "what is the day": `Today is ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}.`,
  };

  const keywordMap = {
    projects: ["project", "portfolio", "apps", "work samples"],
    technologies: ["tech", "stack", "skills", "languages", "tools", "frameworks"],
    contact: ["contact", "email", "reach", "get in touch"],
    experience: ["experience", "background", "career", "past work"],
    passion: ["passion", "motivated", "interests", "drive"],
    teamwork: ["team", "collaboration", "coworkers", "group", "colleagues"],
    education: ["education", "studies", "degree", "formation", "learning"],
    examples: ["example", "demo", "portfolio", "sample"],
    availability: ["available", "free", "schedule", "time", "availability"],
    time: ["what time is", "tell me the time", "current time"],
    day: ["what day is", "tell me the day", "current day"],
    how_are_you: ["how are you", "how is it going", "are you ok"],
  };

  const [messages, setMessages] = useState([
    {
      text: "Hello! I'm Onkar's portfolio assistant. Ask me about his projects, technologies, or how to get in touch with him.",
      sender: "bot",
    },
  ]);
  const [input, setInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Normalizar la entrada y buscar coincidencias
  const handleSend = () => {
    if (input.trim() === "") return;

    const newMessages = [...messages, { text: input, sender: "user" }];
    setMessages(newMessages);
    setInput("");

    // Normalizar la pregunta (minúsculas y eliminar caracteres innecesarios)
    const normalizedInput = input.trim().toLowerCase().replace(/[^\w\s]/g, "");

    let botReply = "Sorry, I don't understand your question. Can you try again or just type the keyword?";
    let foundMatch = false;

    // Buscar una coincidencia en el keywordMap
    for (const key in keywordMap) {
      if (keywordMap[key].some(keyword => normalizedInput.includes(keyword))) {
        botReply = faq[key];
        foundMatch = true;
        break; // Encontramos una coincidencia, podemos detener la búsqueda
      }
    }

    // Si no se encontró en el keywordMap, intentamos una coincidencia directa en el FAQ (como antes)
    if (!foundMatch) {
      for (const key in faq) {
        if (normalizedInput.includes(key)) {
          botReply = faq[key];
          break;
        }
      }
    }

    // Añadir la respuesta del bot al estado
    setMessages([...newMessages, { text: botReply, sender: "bot" }]);
  };

  return (
    <>
      <button
        className="bot-btn fixed bottom-6 right-6 text-white p-4 rounded-full shadow-lg hover:bg-blue-700"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FaRobot size={24} className="animate-bounce" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.3 }}
            className="bot-container fixed bottom-20 right-6 bg-white border-3 rounded-2xl shadow-2xl w-80 p-4 flex flex-col"
          >
            <div className="msg-container h-64 overflow-y-auto flex flex-col gap-2 mb-2">
              {messages.map((msg, index) => (
                <div
                  key={index}
                  className={`flex ${msg.sender === "bot" ? "justify-start" : "justify-end"}`}
                >
                  <div
                    className={`p-2 rounded-lg max-w-xs ${msg.sender === "bot" ? "bg-chatbot" : "bg-blue-500 text-white"}`}
                  >
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex">
              <input
                type="text"
                className="border rounded-l-lg p-2 flex-grow"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Ask something..."
              />
              <button
                className="chatbot-send p-2 rounded-r-lg"
                onClick={handleSend}
              >
                Send
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
